import { memo } from 'react';
import type { TagColorVariant } from '../../constants';
import Tag, { TagVariant } from '../tag/tag';

interface DisplayStatusTagProps {
  displayStatus: {
    type: TagColorVariant;
    text: string;
  };
  textPrefix?: string;
}

const DisplayStatusTag = ({
  displayStatus,
  textPrefix,
}: DisplayStatusTagProps) => {
  const { type, text } = displayStatus;
  const name = textPrefix ? `${textPrefix} ${text}` : text;
  return (
    <Tag
      colorVariant={type}
      name={name}
      variant={TagVariant.Outlined}
      data-testid="enrolment-status"
      isTruncated
    />
  );
};

export default memo(DisplayStatusTag);
